import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import axios from "axios";
import { getGlobals } from "../../Configs";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import HeaderComponent from "../CycleCountCounting/processComponent/HeaderComponent";
import ReportModal from "./ReportModal";
import { confirmAlert } from "react-confirm-alert";

const CycleCountVariance = () => {
  const uMediaQuery = useMediaQuery("(max-width:400px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:900px)");
  const aMediaQuery = useMediaQuery("(max-width:1300px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const [countingSummary, setCountingSummary] = useState([]);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [tableData, setTableData] = useState({
    voucherType: [],
    reason: [],
  });

  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const [filterState, setFilterState] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
      1,
      0,
      0
    ),
    dateTo: new Date(),
    location: LocWithRights.length > 0 ? LocWithRights[0].Uid : [],
    status: "All",
  });

  console.log("filterState>>", filterState);
  const status = ["All", "Enter", "Post"];
  const baseURL = getGlobals().API_BASE_URL;

  useEffect(() => {
    getCyclicAttributes();
  }, []);
  const handleRowClick = (params) => {
    setSelectedRow(params.row); // Store full row data
    setOpen(true);
  };
  const fFilter = () => {
    setOpenFilterModal(true);
  };
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  // Columns for the DataGrid
  const columns = [
    {
      field: "A_SheetId",
      headerName: "SheetID",
      width: 60,
    },
    {
      field: "A_Date",
      headerName: "Date",
      width: 90,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "LocName",
      headerName: "Location",
      width: aMediaQuery ? 150 : 0,
      flex: aMediaQuery ? 0 : 1,
    },
    {
      field: "A_RefNo",
      headerName: "Ref.No",
      width: xMediaQuery ? 80 : 100,
      hide: true,
    },
    {
      field: "A_Narration",
      headerName: "Narration",
      width: xMediaQuery ? 150 : 200,
      hide: true,
    },
    { field: "A_Status", headerName: "Status", width: 60 },
    { field: "A_CountStatus", headerName: "Count St", width: 70 },
    { field: "A_VarianceStatus", headerName: "Variance St", width: 80 },
    { field: "A_FinalPosted", headerName: "Final St", width: 70 },
    {
      field: "RefVocTyp",
      headerName: "RefVocTyp",
      width: xMediaQuery ? 150 : 220,
      renderCell: (params) => {
        const isDisabled =
          params.row?.A_VarianceStatus === "POST" &&
          params.row?.A_FinalPosted === "POST";

        const initialVocTyp =
          params.row.RefVocTyp ||
          (tableData?.voucherType?.length > 0
            ? tableData?.voucherType[0]?.VocTyp
            : "");

        return isDisabled ? (
          <TextField
            sx={{
              "& .MuiInputBase-input": {
                height: "auto !important",
                padding: vMediaQuery
                  ? "4px 4px !important"
                  : "5.5px 10px !important",
              },
              "& .MuiOutlinedInput-input.Mui-disabled": {
                WebkitTextFillColor: "rgba(0, 0, 0, 0.84)",
              },
            }}
            fullWidth
            value={params.row.AdjustmentTypeName || ""}
            variant="outlined"
            size="small"
            disabled
          />
        ) : (
          <Select
            sx={{
              "& .MuiInputBase-input": {
                height: "auto !important",
                padding: vMediaQuery
                  ? "4px 4px !important"
                  : "5.5px 10px !important",
              },
            }}
            value={initialVocTyp}
            onChange={(event) =>
              handleUpdate(params.row, "RefVocTyp", event.target.value)
            }
            fullWidth
          >
            {tableData?.voucherType?.map((typ) => (
              <MenuItem key={typ.VocTyp} value={typ.VocTyp}>
                {typ.VocName}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },

    {
      field: "A_Reason",
      headerName: "Reason",
      width: xMediaQuery ? 150 : 220,
      renderCell: (params) => {
        const isDisabled =
          params.row?.A_VarianceStatus === "POST" &&
          params.row?.A_FinalPosted === "POST";

        const initialReason =
          params.row.A_Reason ||
          (tableData?.reason?.length > 0 ? tableData?.reason[0]?.Uid : "");

        return isDisabled ? (
          <TextField
            sx={{
              "& .MuiInputBase-input": {
                height: "auto !important",
                padding: vMediaQuery
                  ? "4px 4px !important"
                  : "5.5px 10px !important",
              },
              "& .MuiOutlinedInput-input.Mui-disabled": {
                WebkitTextFillColor: "rgba(0, 0, 0, 0.84)",
              },
            }}
            fullWidth
            value={params.row.Reason || ""}
            variant="outlined"
            size="small"
            disabled
          />
        ) : (
          <Select
            sx={{
              "& .MuiInputBase-input": {
                height: "auto !important",
                padding: vMediaQuery
                  ? "4px 4px !important"
                  : "5.5px 10px !important",
              },
            }}
            value={initialReason}
            onChange={(event) =>
              handleUpdate(params.row, "A_Reason", event.target.value)
            }
            fullWidth
          >
            {tableData?.reason?.map((reason) => (
              <MenuItem key={reason.Uid} value={reason.Uid}>
                {reason.Name1}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    {
      field: "Generate",
      headerName: "Variance",
      width: 80,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleVarianceClick(params.row)}
          sx={{ padding: "1px 6px", textTransform: "capitalize" }}
          disabled={
            // params.row?.A_CountStatus === "POST" ||
            params.row?.A_FinalPosted === "POST"
          }
        >
          Generate
        </Button>
      ),
    },
    {
      field: "Report",
      headerName: "Report",
      width: 80,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleReport(params.row)}
          sx={{ padding: "1px 6px", textTransform: "capitalize" }}
        >
          Report
        </Button>
      ),
    },
    {
      field: "Adjustment",
      headerName: "Post",
      width: 100,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handlePostClick(params.row)}
          sx={{ padding: "1px 6px", textTransform: "capitalize" }}
          disabled={
            params.row?.A_VarianceStatus === "POST" &&
            params.row?.A_FinalPosted === "POST"
          }
        >
          Adjustment
        </Button>
      ),
    },
  ];
  console.log(tableData.reason);
  useEffect(() => {
    if (
      tableData.reason?.length &&
      tableData.voucherType?.length &&
      countingSummary.length > 0
    ) {
      const updatedSummary = countingSummary.map((row) => ({
        ...row,
        A_Reason: row.A_Reason || tableData.reason[0].Uid,
        RefVocTyp:
          row.RefVocTyp ||
          (tableData.voucherType && tableData.voucherType.length > 0
            ? tableData.voucherType[0].VocTyp
            : ""),
      }));
      setCountingSummary(updatedSummary);
    }
  }, [tableData]);

  const handleUpdate = (row, field, value) => {
    // Create a new array by mapping over the current state
    const updatedSummary = countingSummary.map((item) => {
      if (item.A_SheetId === row.A_SheetId) {
        // Return a new object with the updated field key
        return { ...item, [field]: value };
      }
      return item;
    });

    // Update the state with the new array
    setCountingSummary(updatedSummary);

    console.log(
      "Updated Row:",
      row.A_SheetId,
      "Field:",
      field,
      "New Value:",
      value
    );
  };

  const handleVarianceClick = (row) => {
    console.log("Variance Button Clicked for Row:", row);

    confirmAlert({
      title: "Generate",
      message: "Are you want to Generate?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            generateCycPhyVariance(row.A_SheetId);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };
  const handleReport = (row) => {
    console.log("Variance Button Clicked for Row:", row);
    setSelectedRow(row);
    setOpenReportModal(true);
  };

  const handlePostClick = (row) => {
    console.log("Post Button Clicked for Row:", row);

    if (
      row.A_Reason === "" ||
      row.A_Reason === null ||
      row.A_Reason === undefined ||
      row.RefVocTyp === "" ||
      row.RefVocTyp === null ||
      row.RefVocTyp === undefined
    ) {
      fAlertToast(
        "FAILED",
        row.A_Reason === "" ||
          row.A_Reason === null ||
          row.A_Reason === undefined
          ? "Reason should not be empty"
          : "Reference Voucher Type should not be empty"
      );
    } else {
      confirmAlert({
        title: "Approve",
        message: "Are you want to Approve?",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              postCycPhyVariance(row);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  const handleLoadBtn = () => {
    getCountingSummary();
    getCyclicAttributes();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const getCountingSummary = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/CycPhyPostingSummary`,
        fcheck_null_undefine_replace_empty({
          P_FromDate: moment(filterState.dateFrom).format("MM/DD/YYYY"),
          P_ToDate: moment(filterState.dateTo).format("MM/DD/YYYY"),
          P_Location: filterState.location,
          P_Status: filterState?.status,
          P_UserCd: vRdxuserInfo?.UserID,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        let GridID = response?.data?.recordset?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setCountingSummary(GridID);
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
    }
  };
  const getCyclicAttributes = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/cyclicAttributes`,
        fcheck_null_undefine_replace_empty({
          userCode: vRdxuserInfo?.UserID,
          userGroupCode: vRdxuserInfo.UserGroupCode,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        setTableData({
          voucherType:
            response?.data?.ResultSet?.DocTypes?.map((item) => ({
              VocTyp: item.VocTyp,
              VocName: item.VocName,
              Paymode: item.Paymode,
            })) || [],
          reason:
            response?.data?.ResultSet?.Reason?.map((item) => ({
              Uid: item.Uid,
              Name1: item.Name1,
            })) || [],
        });

        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
    }
  };

  const generateCycPhyVariance = async (sheetId) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/generateCycPhyVariance`,
        fcheck_null_undefine_replace_empty({
          v_D_UserCd: vRdxuserInfo?.UserID,
          v_D_SheetNo: sheetId,
        })
      );
      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Generated successfully");
      }
      getCountingSummary();
      getCyclicAttributes();
    } catch (error) {
      console.error("Error fetching cycle count data:", error);

      // ✅ Extract error message from API response
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `Error: ${errorMessage}`);
    } finally {
      loader.style.display = "none";
    }
  };
  const postCycPhyVariance = async (row) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/postCycPhyVariance`,
        fcheck_null_undefine_replace_empty({
          v_SheetId: row.A_SheetId,
          v_VocTyp: row.RefVocTyp,
          v_AdjReason: row.A_Reason,
          v_UserId: vRdxuserInfo?.UserID,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Posted successfully");
        // loader.style.display = "none";
      }
      getCountingSummary();
      getCyclicAttributes();
    } catch (error) {
      console.error("Error fetching cycle count data:", error);

      // ✅ Extract error message from API response
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `Error: ${errorMessage}`);
    } finally {
      loader.style.display = "none";
    }
  };

  useEffect(() => {
    getCountingSummary();
  }, []);

  return (
    <div className="div-container">
      <Box pt={2}>
        {/* Title */}
        {vMediaQuery ? (
          <Grid container>
            <Grid
              item
              xs={9.6}
              sm={7}
              md={11}
              marginTop={uMediaQuery ? 0.5 : 0}
            >
              <Typography
                variant="h6"
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600 }}
              >
                Physical Stock Variance
              </Typography>
            </Grid>
            <Grid item xs={1} sm={2.5} md={1} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Physical Stock Variance
            </Typography>

            <HeaderComponent
              status={status}
              vMediaQuery={vMediaQuery}
              handleLoadBtn={handleLoadBtn}
              setFilterState={setFilterState}
              filterState={filterState}
              vRdxDBLocation={LocWithRights}
            />
          </>
        )}

        {/* DataGrid Section */}
        <Box
          sx={{
            height: vMediaQuery ? "80vh" : xMediaQuery ? "65vh" : "72vh",
            width: "100%",
            mt: vMediaQuery ? 4 : 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "white", // Ensures header stays visible
                zIndex: 110,
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
               '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            rows={countingSummary ? countingSummary : ""}
            getRowId={(v) => v.A_SheetId}
            columns={columns}
            onRowClick={handleRowClick}
            components={{
              Toolbar: GridToolbar,
            }}
          />
        </Box>

        <CycleCustomModal
          open={openFilterModal}
          onClose={() => setOpenFilterModal(false)}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="Filter"
        >
          <HeaderComponent
            closeModal={() => setOpenFilterModal(false)}
            status={status}
            vMediaQuery={vMediaQuery}
            setFilterState={setFilterState}
            filterState={filterState}
            vRdxDBLocation={LocWithRights}
            handleLoadBtn={handleLoadBtn}
          />
        </CycleCustomModal>

        <CycleCustomModal
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="Report"
        >
          <ReportModal sheetId={selectedRow?.A_SheetId} />
        </CycleCustomModal>
      </Box>
    </div>
  );
};

export default CycleCountVariance;
